import { render, staticRenderFns } from "./goods-review.vue?vue&type=template&id=8a8efb96&"
import script from "./goods-review.vue?vue&type=script&lang=js&"
export * from "./goods-review.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports